import { h5Injection, panelInjection } from "@nio-fe/nio-h5-debugger";
import { getEnv } from "@nio-wad/hooks";

export const handleInjection = () => {
  try {
    setTimeout(() => {
      const env = getEnv()
      // 环境变量取的缓存
      if (env === "dev" || env === "test" || env === "stg") {
        // 注入调试工具：浮框 (非生产环境用)
        panelInjection &&
          panelInjection("vconsole").then(() => {
            console.log("vconsole 注入成功");
          });
      } else {
        // 注入调试工具：扫码出现 vconsole. (可以用于生产环境)
        h5Injection && h5Injection();
      }
    }, 0);
  } catch (e) {
    console.error("注入调试工具失败  :>>", e);
  }
};
